import Sentosacove1 from "./sentosacove (1).webp";
import Sentosacove2 from "./sentosacove (2).webp";

const sentosacove = [Sentosacove1, Sentosacove2];

export default sentosacove;
